import React, { useEffect, useRef, useState } from "react";
import {
    AESEncryption,
    ApiResDecrypt,
    onlyNumber,
} from "../../../CommonMethhods/CommonMethods";
import * as Yup from "yup";
import { useDebounce } from "../../../Components/useDebounce";
import LoaderForSearch from "../../../Components/Common/LoaderForSearch";
import { partner_Api, Partner_Reports } from "../../../Configuration/Partner_URL";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import PayoutMasterTable from "./PayoutMasterTable";
import { toast } from "react-toastify";
import { Tab } from "react-bootstrap";
import { axiosPartnerJsonReserv1 } from "../../../CommonMethhods/axiosPartnerInterceptor";

function PartnerPayoutMaster(props) {
    const checkTab = props?.checkTab;
    const storeToken = localStorage.getItem("ssoToken");
    const partnerSsoToken = localStorage.getItem("partnerSsoToken");
    const partnerFlag = localStorage.getItem("partnerFlag");
    const [apCode, setApCode] = useState("");
    const [partnerCode, setPartnerCode] = useState("");
    const [count, setCount] = useState("");
    const [partnercount, setPartnerCount] = useState("");
    const [limit, setLimit] = useState(10)
    const [limitPCode, setLimitPCode] = useState(10)
    const [offset, setOffset] = useState(1)
    const [offsetPCode, setOffsetPCode] = useState(1)
    const [apCodeList, setApCodeList] = useState([]);
    const [partCodeList, setPartCodeList] = useState([]);
    const [scrollLoader, setScrollLoader] = useState(false);
    const [scrollLoaderPCode, setScrollLoaderPCode] = useState(false);
    const [addData, setAddData] = useState(false);
    const [show, setShow] = useState(false);
    const [showPcode, setShowPcode] = useState(false);
    const [apErr, setApErr] = useState("");
    const [partErr, setPartErr] = useState("");
    const [flagCheck, setFlagCheck] = useState("insert")

    const debouncedValue = useDebounce(apCode, 1000);
    const debouncedPCodeValue = useDebounce(partnerCode, 1000);

    useEffect(() => {
        handleClientName(debouncedValue);
    }, [debouncedValue]);

    useEffect(() => {
        handlePcode(debouncedPCodeValue);
    }, [debouncedPCodeValue]);

    const dropdownRef = useRef(null);
     const partnerDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

   useEffect(() => {
    const handleClickOutside = (event) => {
      if (partnerDropdownRef.current && !partnerDropdownRef.current.contains(event.target)) {
        setShowPcode(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

    const errorSchema = Yup.object().shape({
        apCode: Yup.string().required("AP Code is required"),
        partnerCode: Yup.string().required("Partner Code is required"),
        sharePercentage: Yup.string().required("Sharing Percentage is required"),
        product: Yup.string().nullable(),
        segment: Yup.string().nullable(),
        apType: Yup.string().nullable(),
        panNum: Yup.string().nullable(),
        bankAccNo: Yup.string().nullable(),
        ifscCode: Yup.string().nullable(),
        bankName: Yup.string().nullable(),
        apReg: Yup.string().nullable(),
        gstReg: Yup.string().nullable(),
        gstNum: Yup.string().nullable(),
        exchange: Yup.string().nullable(),
        sapCode: Yup.string().nullable(),
        bseRegisNum: Yup.string().nullable(),
        nseRegisNum: Yup.string().nullable(),

    });

    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        watch,
        setError,
        clearErrors,
        trigger,
        reset: resetForm,
        formState: { errors, isDirty, isValid },
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(errorSchema),
    });

    async function getApCodes(code, NoPage) {
        setScrollLoader(true);
        const partnerPayload = {
            search: code,
            offset: NoPage,
            limit: 10,
        };

        const encPayload = AESEncryption(partnerPayload)
        try {
            const getSearchDetail = await axiosPartnerJsonReserv1.post(

                partner_Api.Get_APCode,
                `"${encPayload}"`,

            );

            const res = ApiResDecrypt(getSearchDetail?.data)
                console.log(res, "apcoderes");

            if (res?.status === 0) {
                setApErr("")
                setCount(res?.data?.totalCnt);
                if (limit > 1) {
                    setApCodeList((prev) => {
                        return [...prev, ...res?.data?.apCodes];
                    });
                } else {
                    setApCodeList(res?.data?.apCodes);
                }
                if (apCode !== "") {
                    getApDetails()
                }
            } else {
                setApCodeList([])
                setApErr(res?.message)
                // toast?.error(res?.message)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setScrollLoader(false);
        }
    }

    async function getApDetails() {
        const partnerPayload = {
            apCode: apCode
        };

        const encPayload = AESEncryption(partnerPayload)
        try {
            const getSearchDetail = await axiosPartnerJsonReserv1.post(

                partner_Api.Get_PayoutModuleDetails,
                `"${encPayload}"`,
            );

            const res = ApiResDecrypt(getSearchDetail?.data)

            if (res?.status === 0) {
                const value = res?.data;
                console.log(res?.data, "vvhvvvh");
                setValue("product", value?.product);
                setValue("segment", value?.segment);
                setValue("apType", value?.apType);
                setValue("panNum", value?.pan);
                setValue("bankAccNo", value?.accNo);
                setValue("ifscCode", value?.ifsc);
                setValue("bankName", value?.bankName);
                setValue("apReg", value?.apRegistered);
                setValue("gstReg", value?.gstRegistered);
                setValue("gstNum", value?.gstNo);
                setValue("exchange", value?.exchange);
                setValue("sapCode", value?.sapCode);
                setValue("nseRegisNum", value?.nseRegNo);
                setValue("bseRegisNum", value?.bseRegNo);

            } else {
                toast.error(res?.message)
            }
        } catch (error) {
            console.log(error);
        } finally {

        }
    }

    function handleClientName(data) {
        if (data) {
            getApCodes(data, 1);
            setApCodeList([]);
            setOffset(1);
        }
    }

    useEffect(() => {
        if (offset > 1) {
            getApCodes(apCode, offset);
        }
    }, [offset]);

    async function getPartnerCodes(code, NoPage) {
        setScrollLoaderPCode(true);
        const partnerPayload = {
            search: code,
            offset: NoPage,
            limit: 10,
        };
        console.log(partnerPayload, "partnerPayload");


        const encPayload = AESEncryption(partnerPayload)
        try {
            const getSearchDetail = await axiosPartnerJsonReserv1.post(

                partner_Api.Get_PartnerCode,
                `"${encPayload}"`,
            );

            const res = ApiResDecrypt(getSearchDetail?.data)

            if (res?.status === 0) {
                console.log(res?.data, "pcodeooo");
                setPartErr("")
                setPartnerCount(res?.data?.totalCnt);
                if (limitPCode > 1) {
                    setPartCodeList((prev) => {
                        return [...prev, ...res?.data?.partnerCodes];
                    });
                } else {
                    setPartCodeList(res?.data?.partnerCodes);
                }
            } else {
                setPartErr(res?.message)
                setPartCodeList([])
                // toast.error(res?.message)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setScrollLoaderPCode(false);
        }
    }

    function handlePcode(data) {
        if (data) {
            getPartnerCodes(data, 1);
            setPartCodeList([]);
            setOffsetPCode(1);
        }
    }

    useEffect(() => {
        if (offsetPCode > 1) {
            getPartnerCodes(partnerCode, offsetPCode)
        }
    }, [offsetPCode])

    const handleScroll = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
            if (!(count <= 10 * offset)) {
                setOffset((prev) => prev + 1);
                setScrollLoader(true);
            }
        }
    };

    const handleScrollPartner = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoaderPCode) {
            if (!(partnercount <= 10 * offsetPCode)) {
                setOffsetPCode((prev) => prev + 1);
                setScrollLoaderPCode(true);
            }
        }
    };

    async function insertDetails(data) {
        const partnerPayload = {
            apCode: data?.apCode,
            partnerCode: data?.partnerCode,
            sharing: parseFloat(data?.sharePercentage),
            product: data?.product,
            segment: data?.segment,
            apType: data?.apType,
            pan: data?.panNum,
            bankName: data?.bankName,
            bankAcNo: data?.bankAccNo,
            ifsc: data?.ifscCode,
            apRegistered: data?.apReg,
            gstRegistered: data?.gstReg,
            gstNo: data?.gstNum,
            exch: data?.exchange,
            sapCode: data?.sapCode,
            nseRegistration: data?.nseRegisNum,
            bseRegistration: data?.bseRegisNum,
            flag: flagCheck
        };
        console.log(partnerPayload, "partnerPayloadInsert");
        

        const encPayload = AESEncryption(partnerPayload)
        try {
            const getSearchDetail = await axiosPartnerJsonReserv1.post(

                partner_Api.Get_ParterDetails,
                `"${encPayload}"`,
            );

            const res = ApiResDecrypt(getSearchDetail?.data)

            if (res?.status === 0) {
                setAddData(true)
                toast.success(res?.data);
                console.log(res?.data, "submitRes");
                resetButton();
                
                
            } else {
                toast.error(res?.message)
            }
        } catch (error) {
            console.log(error);
        } finally {

        }
    }

    const finalSubmit = (data) => {
        console.log(data, "payoutSubmit");
        insertDetails(data)
    };

    function resetButton() {
        resetForm({
            // apCode: "",
            // partnerCode: "",
            sharePercentage: "",
            product: "",
            segment: "",
            apType: "",
            panNum: "",
            bankAccNo: "",
            ifscCode: "",
            bankName: "",
            apReg: "",
            gstReg: "",
            gstNum: "",
            exchange: "",
            sapCode: "",
            bseRegisNum: "",
            nseRegisNum: "",
        });
        setFlagCheck("insert")
        setApCode("");
        setPartnerCode("");
        clearErrors();
        setApCodeList([]);
        setPartCodeList([]);
    }

    function forUpdateMaster(data) {
        console.log(data, "updatedData");
        setApCode(data?.apCode);
        setPartnerCode(data?.partnerCode);
        setFlagCheck("update")
        resetForm({
        // apCode: data?.apCode,
        // partnerCode: data?.partnerCode,
        sharePercentage: data?.partnerSharing,
        product: data?.partnerModule,
        segment: data?.segment,
        apType: data?.apType,
        panNum: data?.pan,
        bankAccNo: data?.bankAcNo,
        ifscCode: data?.ifsc,
        bankName: data?.bankName,
        apReg: data?.apRegistered,
        gstReg: data?.gstRegistered,
        gstNum: data?.gstRegistered,
        exchange: data?.exch,
        sapCode: data?.sapCode,
        bseRegisNum: data?.bseRegistration,
        nseRegisNum: data?.nseRegistration,
        });
    
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  useEffect(()=>{
        if(apCode === ""){
            resetButton();
            return;
        }

        if (apErr !== "") {
            resetButton();
        }

        if(checkTab !== "payout"){
            resetButton();
        }
    }, [apCode, apErr, checkTab])

  console.log(flagCheck, "addData");
  
    return (
        <>

            <div className='social-media partner-payout'>
                <form onSubmit={handleSubmit(finalSubmit)}>
                    <div className="card-box">
                        <div className="row input-field-wrapper">
                            <div className="section">
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group" ref={dropdownRef} >
                                        <label className="form-label">
                                            AP Code
                                            <span className="partner-mandetory">*</span>
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                className="input-st"
                                                placeholder="Search here..."
                                                autoComplete="off"
                                                value={apCode}
                                                {...register("apCode")}
                                                maxLength={15}
                                                onChange={(e) => {
                                                    // const val = e.target.value.toUpperCase();
                                                    // const filtered = val.replace(/[^A-Z0-9]/g, "");
                                                    // setApCode(filtered);
                                                    // setApErr(""); 
                                                    // clearErrors("apCode")
                                                    // setShow(true);

                                                    const { selectionStart, selectionEnd, value } = e.target;

                                                        let input = value
                                                        .toUpperCase()
                                                        .replace(/[^A-Z0-9]/g, "")
                                                        .slice(0, 15);

                                                        e.target.value = input;
                                                        e.target.setSelectionRange(selectionStart, selectionEnd);
                                                        setApCode(input);
                                                        setApErr(""); 
                                                        clearErrors("apCode")
                                                        setShow(true);
                                                }}
                                                onPaste={(e) => {
                                                    e.preventDefault();
                                                    const pasteText = e.clipboardData.getData("text").toUpperCase().trim();
                                                    const filtered = pasteText.replace(/[^A-Z0-9]/g, "").slice(0, 15);
                                                    setApCode(filtered);
                                                    setApErr("");
                                                    clearErrors("apCode");
                                                    setShow(true);
                                                }}
                                            />
                                            <button
                                                className="rm-dropdown-btn"
                                                type="button"
                                                onClick={() => setShow(!show)}
                                            >
                                                <span className="icon-right-arrow-triangle"></span>
                                            </button>
                                            {show && (
                                                <>
                                                    <ul
                                                        className="rm-mapping-ap border-0"
                                                        onScroll={(e) => handleScroll(e)}
                                                    >
                                                        {apCodeList &&
                                                            apCodeList.map((item, i) => (
                                                                <li
                                                                    key={i}
                                                                    className="rm-maping-item-wrapper"
                                                                    onClick={() => {
                                                                        setApCode(item?.apCode);
                                                                        setShow(false);
                                                                        setValue("apCode", item?.apCode);
                                                                        console.log(item?.apCode, "apCode");
                                                                    }}
                                                                >
                                                                    {/* <div> {item?.clientName}</div> */}
                                                                    <div> {item?.apCode}</div>

                                                                </li>
                                                            ))}
                                                        {scrollLoader && (
                                                            <div className="loader-center">
                                                                <LoaderForSearch />
                                                            </div>
                                                        )}
                                                        {apErr && !scrollLoader && (
                                                    <li
                                                        className="rm-maping-item-wrapper"
                                                        style={{
                                                        borderBottom: "none",
                                                        fontSize: "12px",
                                                        }}
                                                    >
                                                        {apErr}
                                                    </li>
                                                    )}
                                                    </ul>
                                                </>
                                            )}
                                        </div>
                                        <div className="ErrorMsg">{errors.apCode?.message}</div>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group" ref={partnerDropdownRef}>
                                        <label className="form-label">
                                            Partner Code
                                            <span className="partner-mandetory">*</span>
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                className="input-st"
                                                maxLength={15}
                                                placeholder="Search here..."
                                                autoComplete="off"
                                                value={partnerCode}
                                                {...register("partnerCode")}
                                                onChange={(e) => {
                                                    const { selectionStart, selectionEnd, value } = e.target;
                                                    const filtered = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                                    // const val = e.target.value.toUpperCase();
                                                    // const filtered = val.replace(/[^A-Z0-9]/g, "");
                                                    setPartnerCode(filtered);
                                                    e.target.value = filtered;
                                                    e.target.setSelectionRange(selectionStart, selectionEnd);
                                                    clearErrors("partnerCode")
                                                    setShowPcode(true);
                                                }}
                                                onPaste={(e) => {
                                                    e.preventDefault();
                                                    const pasteText = e.clipboardData.getData("text").toUpperCase();
                                                    const filtered = pasteText.replace(/[^A-Z0-9]/g, "");
                                                    setPartnerCode(filtered);
                                                    clearErrors("partnerCode");
                                                    setShowPcode(true);
                                                }}
                                            />
                                            <button
                                                className="rm-dropdown-btn"
                                                type="button"
                                                onClick={() => setShowPcode(!showPcode)}
                                            >
                                                <span className="icon-right-arrow-triangle"></span>
                                            </button>
                                            {showPcode && (
                                                <>
                                                    <ul
                                                        className="rm-mapping-ap border-0"
                                                        onScroll={(e) => handleScrollPartner(e)}
                                                    >
                                                        {partCodeList &&
                                                            partCodeList.map((item, i) => (
                                                                <li
                                                                    key={i}
                                                                    className="rm-maping-item-wrapper"
                                                                    onClick={() => {
                                                                        setPartnerCode(item?.partnerCode);
                                                                        setShowPcode(false);
                                                                        setValue("partnerCode", item?.partnerCode);
                                                                        console.log(item?.partnerCode, "partnerCode");


                                                                    }}
                                                                >

                                                                    <div> {item?.partnerCode}</div>

                                                                </li>
                                                            ))}
                                                        {scrollLoaderPCode && (
                                                            <div className="loader-center">
                                                                <LoaderForSearch />
                                                            </div>
                                                        )}
                                                        {partErr && !scrollLoaderPCode && (
                                                    <li
                                                        className="rm-maping-item-wrapper"
                                                        style={{
                                                        borderBottom: "none",
                                                        fontSize: "12px",
                                                        }}
                                                    >
                                                        {partErr}
                                                    </li>
                                                    )}
                                                    </ul>
                                                </>
                                            )}
                                        </div>
                                        <div className="ErrorMsg">{errors.partnerCode?.message}</div>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Sharing Percentage
                                            <span className="partner-mandetory">*</span>
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                maxLength={3}
                                                onInput={onlyNumber}
                                                className="input-st"
                                                {...register("sharePercentage")}
                                                placeholder="Enter sharing percentage"
                                                autoComplete="off"
                                                onChange={(e) => {
                                                let value = e.target.value.replace(/[^0-9]/g, "");
                                                if (value.length > 1 && value.startsWith("0")) {
                                                    value = value.replace(/^0+/, "");
                                                }

                                                    if (value !== "") {
                                                        clearErrors("sharePercentage");
                                                        const num = parseInt(value, 10);
                                                    if (num > 100) {
                                                        value = "100";
                                                    } else if (num < 1) {
                                                        value = "";
                                                        }
                                                    }
                                                    setValue("sharePercentage", value, { shouldValidate: true, shouldDirty: true });


                                                // e.target.value = value;
                                            }}
                                            onPaste={(e) => {
                                                e.preventDefault();
                                                let pasteData = e.clipboardData.getData("text").replace(/[^0-9]/g, "");

                                                if (pasteData.length > 1 && pasteData.startsWith("0")) {
                                                    pasteData = pasteData.replace(/^0+/, "");
                                                }

                                                if (pasteData) {
                                                const num = parseInt(pasteData, 10);
                                                clearErrors("sharePercentage");
                                                if (num > 100) pasteData = "100";
                                                else if (num < 1) pasteData = "";
                                                }
                                                  setValue("sharePercentage", pasteData, { shouldValidate: true, shouldDirty: true });

                                                // document.execCommand("insertText", false, pasteData);
                                            }}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.sharePercentage?.message}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            Product
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                className="input-st"
                                                {...register("product")}
                                                placeholder="Enter product"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.product?.message}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="section">
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            Segment
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("segment")}
                                                placeholder="Enter segment"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.segment?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            AP Type
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                className="input-st"
                                                {...register("apType")}
                                                placeholder="Enter AP type"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.apType?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            PAN Number
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("panNum")}
                                                placeholder="Enter PAN Number"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.panNum?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            Bank Account Number
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("bankAccNo")}
                                                placeholder="Enter Bank Account Number"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.bankAccNo?.message}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="section">
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            IFSC Code
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("ifscCode")}
                                                placeholder="Enter PAN Number..."
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.ifscCode?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            Bank Name
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("bankName")}
                                                placeholder="Enter Bank Name"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.bankName?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            AP Registered
                                            <span className="partner-mandetory">*</span>
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("apReg")}
                                                placeholder="Enter AP"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.apReg?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            GST Registered
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("gstReg")}
                                                placeholder="Enter GST Registered"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.gstReg?.message}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="section">
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            GST Number
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("gstNum")}
                                                placeholder="Enter GST Number"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.gstNum?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            Exchange
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("exchange")}
                                                placeholder="Enter Exchange"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.exchange?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            SAP Code
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("sapCode")}
                                                placeholder="Enter SAP Code"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.sapCode?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            BSE Registration Number
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                // maxLength={10}
                                                className="input-st"
                                                {...register("bseRegisNum")}
                                                placeholder="Enter BSE Registration Number"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.bseRegisNum?.message}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="section">
                                <div className="col-md-3 col-sm-3 col-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label disable-label">
                                            NSE Registration Number
                                            {/* <span className="partner-mandetory">*</span> */}
                                        </label>
                                        <div className="rm-custom-dropdown">
                                            <input
                                                type="text"
                                                name="search-text"
                                                className="input-st"
                                                {...register("nseRegisNum")}
                                                placeholder="Enter NSE Registration Number"
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="ErrorMsg">
                                            {errors.nseRegisNum?.message}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="save-reset-btn">
                            <button
                                type="button"
                                className="margin-reset-btn"
                                onClick={resetButton}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="margin-save-btn"
                                disabled={apErr || partErr}
                            >
                                Submit
                                {/* {submitBtn ? Constants.Submit : "Update"} */}
                            </button>

                        </div>
                        <div>
                            <Tab.Content>
                            <PayoutMasterTable 
                                setAddData={setAddData}
                                addData={addData}
                                forUpdateMaster={forUpdateMaster} />
                            </Tab.Content>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default PartnerPayoutMaster;
